import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserQuery } from '../../core/state/user/user.query';
import { ProfileService } from '../../core/services/profile.service';
import { User } from '../../core/state/user/user.model';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({checkProperties: true})
@Component({
  selector: 'app-payment-details',
  templateUrl: './payment-details.component.html',
  styleUrls: ['./payment-details.component.scss']
})
export class PaymentDetailsComponent implements OnInit {
  @ViewChild('saveBtn') saveBtn: ElementRef;
  user: User;
  form: FormGroup;

  constructor(private fb: FormBuilder,
              private renderer: Renderer2,
              private userQuery: UserQuery,
              private profileService: ProfileService) { }

  ngOnInit(): void {
    this.userQuery.select().subscribe($user => {
      this.user = $user.account;
    });

    this.form = this.fb.group({
      id: [this.user.id],
      TIN: [this.user.profile.TIN, Validators.required],
      gcash: [this.user.profile.gcash, Validators.required],
      bank: [this.user.profile.bank],
      accountName: [this.user.profile.bank_acct_name],
      accountNumber: [this.user.profile.bank_acct_num]
    });
  }

  get f(): any { return this.form.controls; }

  update(): void {
    this.renderer.setProperty(this.saveBtn.nativeElement, 'disabled', 'true');
    this.renderer.setProperty(this.saveBtn.nativeElement, 'innerText', 'Saving...');

    this.profileService.updatePayment(this.form.value).subscribe(
      res => {
        this.renderer.removeAttribute(this.saveBtn.nativeElement, 'disabled');
        this.renderer.setProperty(this.saveBtn.nativeElement, 'innerText', 'Save');
      },
      error => {
        this.renderer.removeAttribute(this.saveBtn.nativeElement, 'disabled');
        this.renderer.setProperty(this.saveBtn.nativeElement, 'innerText', 'Save');
      }
    );
  }

}
